import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Для начала работы выберите сервис в левом меню сайта.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Вы можете открывать сразу несколько вкладок одного или разных сервисов внутри одного окна портала (браузера). ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.header)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.user)
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(_ctx.$style.avatar),
          src: _ctx.userAvatar,
          alt: _ctx.user.first_name + ' ' + _ctx.user.last_name
        }, null, 10, _hoisted_1),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.name)
        }, _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 3)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.body)
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.sectionTitle)
      }, "Добро пожаловать!", 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.card)
      }, _hoisted_4, 2)
    ], 2)
  ], 2))
}